import tokensStorage from "./tokensStorage";

export default class AuthenticationManager {
    constructor(authorizationServerUrl, clientId, redirectUri) {
        this._authorizationServerUrl = authorizationServerUrl;
        this._clientId = clientId;
        this._redirectUri = redirectUri;
    }

    runAuthorizationCodeFlow(state, adaptor = 'rms_customer') {
        this._throwErrorWhenInInvalidState();

        const authorizationUrl = this._getRedirectUrl('code', state, adaptor, 'openid');

        window.location = authorizationUrl;
    }

    storeTokens(tokensModel) {
        if (!tokensModel || !tokensModel.tokenType || !tokensModel.accessToken || !tokensModel.refreshToken) {
            throw new Error('Authentication Manager: Unable to store tokens - missing tokens are found.');
        }

        tokensStorage.store(tokensModel);
    }

    getTokens() {
        return tokensStorage.get();
    }

    removeTokens() {
        return tokensStorage.remove();
    }

    _getRedirectUrl(responseType, state, adaptor, scope) {
        const params = {
            adaptor,
            client_id: this._clientId,
            response_type: responseType,
            redirect_uri: this._redirectUri,
            state,
            scope
        };

        const queryString = $.param(params);

        return `${this._authorizationServerUrl}/auth/authorization.oauth2?${queryString}`;
    }

    _throwErrorWhenInInvalidState() {
        if (!this._authorizationServerUrl || !this._clientId || !this._redirectUri) {
            throw new Error(
                'Authentication Manager: Some of parameters are missing.'
                + ` authorizationServerUrl: ${this._authorizationServerUrl};`
                + ` clientId: ${this._clientId};`
                + ` redirectUri: ${this._redirectUri};`
            );
        }
    }
}
